// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WebComponent_wrapper__Atpgv"};